require('./bootstrap');
require('./hamburger');
// require('./cookie');
require('./slide-to-section');
// require('./smooth-scroll');
// require('./visible');
// require('./sendmail');
require('lightgallery');
require('lightgallery/modules/lg-thumbnail.min.js');
require('lightgallery/modules/lg-autoplay.min.js');
require('lightgallery/modules/lg-fullscreen.min.js');
require('lightgallery/modules/lg-share.min.js');
require('lightgallery/modules/lg-zoom.min.js');
require('lightgallery/modules/lg-video.min.js');

import Splide from '@splidejs/splide';

$(document).ready(function() {

    $("#lightgallery").lightGallery({ selector: '.gallery-item' });

    if($('#splide').length){
        new Splide( '#splide', {
            type: 'loop',
            perPage: 4,
            perMove: 1,
            arrows: true,
            rewind: true,
            pagination:true,
            height: '250px',
            gap: 10,
            // padding: { left: 0, right: 150 },
            breakpoints: {
                768: {
                    perPage: 1,
                    arrows: false,
                    // padding: { left: 0, right: 25 },
                    // gap: 10,
                },
            }
        } ).mount();
    }
    // $(".scroll-to-top").click(function(){
    //     $('html,body').animate({ scrollTop: 0 }, 'slow');
    //     return false;
    // });

    // onScroll();
    // $(document).on("load", onScroll);
    // $(document).on("scroll", onScroll);

});


function onScroll(event) {
    const element = $('h2 span');
    element.each(function(i, elem) {
        if ($(elem).visible(true)) {
            var windowHeight = window.innerHeight;
            let width =  100 - ($(elem).offset().top - $(window).scrollTop()) / windowHeight * 100;
            elem.style.setProperty('--width', width * 1.5 + 'vw');
        }
    });
}
